import React from "react";
import { observer } from "mobx-react";

import Slider from "react-slick";
import { MobileSettings } from "@utils/quick-play/slider";
import BettingTipsListItem from "./BettingTipsListItem";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { OfferStore } from "@state/context/offer/OfferContext";

export default observer(function BettingTipsEventList() {
	const store = useOfferContext<OfferStore.EventViewStore>();

	const data = store?.bettingTipsStore.bettingTips;

	return (
		<div className="section section--play event__slider">
			<div className="section--play__body">
				<Slider {...MobileSettings} className="carousel carousel--most">
					{data.map((tip, index) => (
						<BettingTipsListItem
							key={tip.id}
							data={tip}
							index={index}
							activatePopup={store.bettingTipsStore.activatePopup}
						/>
					))}
				</Slider>
			</div>
		</div>
	);
});
